import React from "react";
import { QuestionCircleOutlined, BellOutlined } from "@ant-design/icons";
import * as cfg from "../../config";
import RequestsHeaderButton from "./RequestsHeaderButton";

export const HeaderDropdownItems = () => [
  {
    key: "help",
    icon: <QuestionCircleOutlined />,
    label: <a href={cfg.sidebar_help}>Help</a>,
  },
  {
    key: "requests",
    icon: <BellOutlined />,
    label: <RequestsHeaderButton />,
  },
];

export default HeaderDropdownItems;
